module.exports = __webpack_public_path__ + "static/media/img108.ca6ddf9a.jpg";